import './CodexLinkButton.css'

function CodexBookIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 7v14" />
      <path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H19v20H8.5A3.5 3.5 0 0 1 5 18.5" />
    </svg>
  )
}

function CodexLinkButton({ onClick, ariaLabel, className = '', compact = false }) {
  return (
    <button
      type="button"
      className={`codex-link-btn${compact ? ' codex-link-btn--compact' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <CodexBookIcon />
      <span>Codex</span>
    </button>
  )
}

export default CodexLinkButton
